import React from 'react'
import styles from './styles.module.css'
import moment from 'moment'
import { Checkbox, Input, Textarea } from '../../../components/ModalInputs'

const Homework = ({ lesson, lessonData, handleLessonDataChange, selectedLesson }) => {

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return moment(dateStr).format('DD.MM.YYYY, dddd');
    }

    return (
        <div className={styles.wrapperHomework}>
            <div className={styles.headerHomework}>

                <div className={styles.homeData}>
                    <Input
                        disabled
                        label='Дата'
                        value={formatDate(selectedLesson?.day)}
                    />
                    <Input
                        disabled
                        label='Предмет'
                        value={lesson?.course_title || selectedLesson?.course || ''}
                    />
                    <Input
                        disabled
                        label='Класс'
                        value={lesson?.class_name || selectedLesson?.groupname || ''}
                    />
                    <div className={styles.homeCheck}>
                        <Checkbox
                            label='Прислать в виде файла преподавателю'
                            checked={lessonData.hw_reqresult === 1}
                            onChange={(e) => handleLessonDataChange('hw_reqresult', e.target.checked ? 1 : 0)}
                        />
                    </div>
                </div>

                <div className={styles.homeTime}>
                    <span>Время на выполнение:</span>
                    <Input
                        type='number'
                        min={0}
                        value={lessonData.hw_hours ?? ''}
                        onChange={(e) => handleLessonDataChange('hw_hours', e.target.value === '' ? null : Number(e.target.value))}
                    />
                    <span>ч</span>
                    <Input
                        type='number'
                        min={0}
                        max={59}
                        value={lessonData.hw_minutes ?? ''}
                        onChange={(e) => handleLessonDataChange('hw_minutes', e.target.value === '' ? null : Number(e.target.value))}
                    />
                    <span>мин</span>
                </div>
            </div>

            <div className={styles.homework}>
                <Textarea
                    label='Текст задания'
                    className={styles.textareaWrapper}
                    textareaClassName={styles.textarea}
                    value={lessonData.hw_text || ''}
                    onChange={(e) => handleLessonDataChange('hw_text', e.target.value)}
                />
            </div>

        </div>
    )
}

export default Homework
